<adapt-objectives-page-navigator buttonText="Record quarterly objectives"
                                 [pageActivationTours]="PageActivationTours"></adapt-objectives-page-navigator>
